import { createClient } from "@supabase/supabase-js";

const PROD_PROJECT_REF = "thtybutuohiajhmsevbb";
const onPreview = window.location.hostname.endsWith(".preview.emergentagent.com");

// Live binding: assigned once by initSupabase() before the app renders.
export let supabase = null;

// Supabase settings come from this environment's backend at runtime (never baked into the build).
export async function initSupabase() {
  let cfg;
  try {
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public-config`, { cache: "no-store" });
    if (!r.ok) throw new Error(String(r.status));
    cfg = await r.json();
  } catch {
    return "Could not load the app configuration from the server.";
  }
  const ref = ((cfg.supabase_url || "").match(/^https:\/\/([a-z0-9]{20})\.supabase\.co/) || [])[1];
  if (!ref || !cfg.supabase_anon_key) return "Supabase project not configured.";
  if (!onPreview && ref !== PROD_PROJECT_REF) return "Production is configured with a non-production (test) Supabase project.";
  if (onPreview && ref === PROD_PROJECT_REF) console.warn("Preview is using the PRODUCTION Supabase project.");
  supabase = createClient(cfg.supabase_url, cfg.supabase_anon_key, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: false, storageKey: `sb-${ref}-auth-token` },
  });
  return null;
}
